@if (contact) {
    <section class="mobi-ui-section-minor mobi-ui-ink-grey">
        <div class="mobi-ui-container" className="osm-contact-organisation">
            <div class="mobi-ui-centered mobi-ui-font-h3 mobi-ui-ink-default">
                {{ 'osm.footer.protekta.contact.title' | translate }}
            </div>
            <div class="mobi-ui-centered">
                <mobi-ui-split-button-group-major
                    (valueChange)="handleValueChange($event)"
                    class="contact-location-split-button mobi-ui-margin-t-md"
                >
                    <mobi-ui-split-button-major value="bern"> Bern </mobi-ui-split-button-major>
                    <mobi-ui-split-button-major value="nyon"> Nyon </mobi-ui-split-button-major>
                </mobi-ui-split-button-group-major>
            </div>
            <mobi-ui-contact-person-major
                [mapLocations]="[
                    {
                        lat: contact.organisationUnit?.geoLocation?.lat,
                        lng: contact.organisationUnit?.geoLocation?.lng,
                    },
                ]"
            >
                <span class="mobi-ui-font-h6">{{ contact.subtitle | translate }}</span>
                <span class="mobi-ui-font-bold contact-title">{{
                    contact.organisationUnit?.names?.name || ''
                }}</span>
                <div class="mobi-ui-card-minor mobi-ui-margin-t-xxs">
                    <div class="mobi-ui-text-block-major is-small">
                        <mobi-ui-icon-major name="house" class="md"></mobi-ui-icon-major>
                        <div class="mobi-ui-text-block-content-major">
                            <h4 class="mobi-ui-text-block-label-major">
                                {{ 'osm.footer.protekta.card.address.label' | translate }}
                            </h4>
                            <span class="mobi-ui-text-block-content">
                                {{ contact.organisationUnit?.addresses?.address?.street || '' }}
                            </span>
                            <span class="mobi-ui-text-block-content-major">
                                {{ contact.organisationUnit?.addresses?.address?.postalCode || '' }}
                                {{ contact.organisationUnit?.addresses?.address?.location || '' }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="mobi-ui-card-minor">
                    <div class="mobi-ui-text-block-major is-small">
                        <mobi-ui-icon-major name="door_handle" class="md"></mobi-ui-icon-major>
                        <div class="mobi-ui-text-block-content-major">
                            <h4 class="mobi-ui-text-block-label-major">
                                {{ 'osm.footer.protekta.card.oeffnungszeiten.label' | translate }}
                            </h4>
                            <span class="mobi-ui-text-block-content-major">
                                {{ 'osm.footer.protekta.card.oeffnungszeiten.tag' | translate }}
                                <br />
                                {{
                                    contact.openinghours?.morning +
                                        ' | ' +
                                        contact.openinghours?.afternoon
                                }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="mobi-ui-margin-t-xxs mobi-ui-text-left link-wrapper">
                    @if (contact.organisationUnit?.webpages?.webpage) {
                        <a
                            class="mobi-ui-link-block-major"
                            [href]="contact.organisationUnit?.webpages?.webpage"
                            target="_blank"
                        >
                            <mobi-ui-icon-major
                                class="mobi-ui-link-block-icon-major"
                                name="right"
                            ></mobi-ui-icon-major>
                            <span class="mobi-ui-link-block-text-major"
                                >{{ 'osm.footer.protekta.card.contact.label' | translate }}
                            </span>
                        </a>
                    }
                </div>
            </mobi-ui-contact-person-major>
        </div>
    </section>
}
